import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { PAGINATION } from '../../common/constants'
import { apolloService } from '../../common/services'

import { MOVE_DICTIONARY_WORD_TO_TYPE_MUTATION } from '../graphql/mutations'
import { MOVE_DICTIONARY_WORD_TO_TYPE } from '../redux/action-types'

const useMoveDictionaryWordToTypeMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const mutate = useCallback(
    async (
      id,
      type,
      pageSize,
      previousType,
      previousTypePageSize,
      previousTypePage,
      filters,
    ) => {
      await apolloService.mutate(
        MOVE_DICTIONARY_WORD_TO_TYPE_MUTATION,
        {
          id,
          type,
          pageSize: pageSize || PAGINATION.DEFAULT_PAGE_SIZE,
          previousType,
          previousTypePageSize:
            previousTypePageSize || PAGINATION.EFAULT_PAGE_SIZE,
          previousTypePage: previousTypePage || PAGINATION.DEFAULT_PAGE,
          filters,
        },
        dispatch,
        MOVE_DICTIONARY_WORD_TO_TYPE,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate]
}

export default useMoveDictionaryWordToTypeMutation
